export { ChipItemDirective } from './chip-item.directive';
